import http from '~/common/http'

export default {

    // 得到用户模型实例
    getModel() {
        return {
            id: 0,
            name: "",
            nickname: "",
            mobile: "",
            role_id: "",
            branch_id: "",
            password_hash: "",
            email: "",
            avatar: "",
            qr_code: "",
            qq: "",
            status: 0,
            is_common: 0,
            state_memo: "",
            created_ip: "",
            created_at: "",
            max_customer_limit: 0,
            max_vip_limit: 0,
            entry_at: '',
        };
    },

    // 得到用户列表
    getList(params) {
        return http.get('/api/users/index', {
            params: params
        });
    },

	// 得到所有用户列表
	getAll(params) {
		return http.get('/api/common/get-users', {
			params: params
		});
	},

    // 得到单个用户信息
    getInfo(userId) {
        return http.get('/api/users/view', {
            params: {
                id: userId
            }
        });
    },

    // 获取用户登录日志列表
    getLoginLogs(params) {
        return http.get('/api/users/login-logs', {
            params: params
        })
    },

    // 创建用户
    create(user) {
        return http.post('/api/users/create', user)
    },

    // 更新用户信息
    update(user) {
        return http.put('/api/users/update?id=' + user.id, user);
    },

    // 批量更新用户个人库容
    updateCapacity(params) {
        return http.post('/api/users/update-capacity', params);
    },

    // 删除用户
    delete(userId) {
        return http.delete('/api/users/delete', {
            params: {
                id: params.id
            }
        });
    },

    // 更新用户信息
    changePwd(user) {
        return http.put('/api/users/change-pwd?id=' + user.id, user);
    },


    
    /**
     * 上传二维码图片
     * @param file
     * @returns {*}
     */
    uploadQRCode(file) {
        let form = new FormData();
        form.append('qr_code', file);
        return http.post('/api/users/upload-qr', form);
    },

    /**
     * 得到适用于用户的地区列表，（对已绑定过的地区已做过滤处理）
     * @param cityId
     * @returns {*}
     */
    getDistricts(cityId) {
        return http.get('/api/users/districts', {
            params: {
                city_id: cityId
            }
        })
    },
    /**
     * 得到适用于用户的地区列表，（对已绑定过的地区已做过滤处理）
     * @param cityId
     * @returns {*}
     */
    getCommonDistricts(cityId,uid) {
        return http.get('/api/users/common-districts', {
            params: {
                city_id: cityId,
                uid:uid
            }
        })
    },

    /**
     * 用户绑定区域列表
     * @param userId
     * @returns {*}
     */
    getAreas(userId) {
        return http.get('/api/users/areas', {
            params: {
                id: userId
            }
        });
    },
    /**
     * 用户绑定公海池区域列表
     * @param userId
     * @returns {*}
     */
    getCommonAreas(userId) {
        return http.get('/api/users/common-areas', {
            params: {
                id: userId
            }
        });
    },


    /**
     * 绑定用户销售区域
     * @param params
     * @returns {*}
     */
    bindArea(params) {
        return http.post('/api/users/bind-district', params)
    },
    /**
     * 绑定用户销售区域
     * @param params
     * @returns {*}
     */
    bindCommonArea(params) {
        return http.post('/api/users/bind-common-district', params)
    },

    /**
     * 解绑用户销售区域
     * @param userId
     * @param districts
     * @returns {*}
     */
    unbindArea(userId, districts) {
        return http.post('/api/users/unbind-district?user_id=' + userId, {
            districts: districts
        })
    },
    /**
     * 解绑用户销售区域
     * @param userId
     * @param districts
     * @returns {*}
     */
    unbindCommonArea(userId, districts) {
        return http.post('/api/users/unbind-common-district?user_id=' + userId, {
            districts: districts
        })
    },

    /**
     * 锁定用户销售区域
     * @param userId
     * @param record_id
     * @returns {*}
     */
    lockArea(userId, record_id) {
        return http.post('/api/users/lock-area?user_id=' + userId, {
            record_id: record_id
        })
    },

    /**
     * 解锁用户销售区域
     * @param userId
     * @param record_id
     * @returns {*}
     */
    unlockArea(userId, record_id) {
        return http.post('/api/users/unlock-area?user_id=' + userId, {
            record_id: record_id
        })
    }
}




// WEBPACK FOOTER //
// ./src/services/user.js